// extracted by mini-css-extract-plugin
export default {"progressBar":"progress_progressBar__o8s7y","seperator":"progress_seperator__Xuxxl","colorPrimary":"progress_colorPrimary__ziDjf","barColorPrimary":"progress_barColorPrimary__hDdvU"};